import { agentApiToken, agentFormApiToken } from "../config/AgentsApiService";

export const generateResourceSuggestions = async (
    request: any
) => {
    try {
        const response = await agentApiToken.post<any>(
            `/agents/employee_suggestions`,
            request
        );

        if (response && response.data) {
            return response.data;
        } else {
            throw new Error("Response is undefined or doesn't contain data");
        }
    } catch (error: any) {
        console.error(
            "Error Response Data:",
            error?.response?.data || error.message
        );
        console.error(
            "Error Response Status:",
            error?.response?.status || "No status available"
        );
        return {
            error: error?.response?.data?.detail || "Unknown error occurred",
            error_status: error?.response?.status || "No status available",
        };
    }
};

export const sowParser = async (
    payload: any
) => {
    try {
        const response = await agentFormApiToken.post<any>(
            `/agents/sow_parser`, payload
        );

        if (response && response.data) {
            return response.data;
        } else {
            throw new Error("Response is undefined or doesn't contain data");
        }
    } catch (error: any) {
        console.error(
            "Error Response Data:",
            error?.response?.data || error.message
        );
        console.error(
            "Error Response Status:",
            error?.response?.status || "No status available"
        );
        return {
            error: error?.response?.data?.detail || "Unknown error occurred",
            error_status: error?.response?.status || "No status available",
        };
    }
};